<template>
  <!-- eslint-disable -->
  <div>
    <!-- Botón flotante para abrir el mini menú -->
    <button class="mini-nav-button" @click="toggleMiniMenu" :style="{
                  backgroundImage: `linear-gradient(139deg, ${prestador.admin.assets.colors.primary} 0%, ${prestador.admin.assets.colors.secondary} 100%)`
                }">
      <i class="ti ti-menu-2"></i>
    </button>

    <!-- Mini SideNav -->
    <transition name="fade">
      <div v-if="showMiniNav" class="mini-side-nav" ref="miniNav">
        <div
          v-for="item in filteredMenu"
          :key="item.nombre"
          class="mini-nav-item"
          @click="goTo(item)"
        >
          <i :class="item.icono" class="mini-nav-icon" :style="{
                  color: `${prestador.admin.assets.colors.secondary}`
                }"></i>
          <span class="mini-nav-text">{{ item.nombre }}</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
/* eslint-disable */
import '@/assets/estilo_importado/vendor/css/rtl/core.css';
import '@/assets/estilo_importado/vendor/css/rtl/theme-default.css';
import '@/assets/estilo_importado/css/demo.css';
import '@/assets/estilo_importado/vendor/libs/node-waves/node-waves.css';
import '@/assets/estilo_importado/vendor/libs/perfect-scrollbar/perfect-scrollbar.css';
import '@/assets/estilo_importado/vendor/libs/typeahead-js/typeahead.css';
import '@/assets/estilo_importado/vendor/fonts/tabler-icons.css';
import '@/assets/estilo_importado/vendor/fonts/fontawesome.css';

import { mapGetters } from 'vuex';

export default {
  name: "MiniSideNav",
  data() {
    return {
      showMiniNav: false,
      menu_items: [
        { nombre: 'Inicio', icono: 'ti ti-smart-home', to: 'Inicio' },
        { nombre: 'Atenciones Agendadas', icono: 'ti ti-shopping-cart', to: 'Ordenes', permissions: ['permiso_general'] },
        { nombre: 'Profesionales', icono: 'ti ti-users', to: 'Profesionales', permissions: ['gestionar_profesionales'] },
        { nombre: 'Calendario', icono: 'ti ti-calendar', to: 'CalendarioGeneral', permissions: ['permiso_general'] },
        { nombre: 'Agendar Atención', icono: 'ti ti-stethoscope', to: 'AgendarAtencion', permissions: ['gestionar_profesionales'], prestadores: ['*'], ocultar_en: [16] },
        { nombre: 'Agendar Atención En Casa', icono: 'ti ti-user', to: 'AgendarAtencionEnCasa', permissions: ['gestionar_profesionales'], prestadores: [16, 23] },
        { nombre: 'Historial Paciente', icono: 'ti ti-user', to: 'HistorialPaciente', permissions: ['gestionar_profesionales'] },
        { nombre: 'Ubicación', icono: 'ti ti-map', to: 'Ubicacion', permissions: ['gestionar_profesionales'] },
        { nombre: 'Reportes Médicos', icono: 'ti ti-chart-pie', to: 'ReportesMedicos', permissions: ['ver_reportes'] },
        { nombre: 'Google Analytics', icono: 'ti ti-brand-google', to: 'GoogleAnalyticsById', permissions: ['ver_reportes'], prestadores: [1, 3, 5, 9, 13, 14, 15, 18, 23] },
        { nombre: 'Cotizador', icono: 'ti ti-cash', to: 'Cotizador', permissions: ['ver_reportes'], prestadores: [13, 23] },
        { nombre: 'Prestaciones', icono: 'ti ti-file-description', to: 'MaestroExamenes', permissions: ['gestionar_prestaciones'] },
        { nombre: 'Aseguradoras', icono: 'ti ti-file-dollar', to: 'Aseguradoras', permissions: ['gestionar_aseguradoras'] },
        { nombre: 'Códigos Descuento', icono: 'ti ti-id', to: 'CodigoDescuentos', permissions: ['gestionar_codigos_descuento'] },
        { nombre: 'Configuraciones', icono: 'ti ti-settings', to: 'CostosServicios', permissions: ['otras_configuraciones'] },
      ],
    };
  },
  computed: {
    ...mapGetters(['admin_datos', 'prestador', 'prestador_id']),
    filteredMenu() {
      return this.menu_items.filter(item => this.hasPermissions(item) && this.hasPrestadorAccess(item));
    },
  },
  methods: {
    toggleMiniMenu() {
      this.showMiniNav = !this.showMiniNav;
    },
    goTo(item) {
      try {
        if (item.to) {
          this.$router.push({ name: item.to });
        }
      } catch (e) {
        console.warn("Ruta inválida:", item.to);
      }
      this.showMiniNav = false;
    },
    hasPermissions(item) {
      if (!item.permissions) return true;
      const perms = this.admin_datos?.permissions || [];
      return item.permissions.every(p => perms.includes(p));
    },
    hasPrestadorAccess(item) {
      const pid = Number(this.prestador?.id ?? this.prestador_id);
      const includesNum = (arr, val) => Array.isArray(arr) && arr.map(Number).includes(val);

      if (!item?.prestadores && !item?.ocultar_en) return true;

      if (item?.prestadores) {
        if (item.prestadores.includes('*')) {
          return !includesNum(item.ocultar_en, pid);
        }
        return includesNum(item.prestadores, pid);
      }

      if (item?.ocultar_en) {
        return !includesNum(item.ocultar_en, pid);
      }

      return true;
    },
    handleClickOutside(event) {
  const el = this.$refs.miniNav;
  const button = event.target.closest('.mini-nav-button');
  // Si el click fue dentro del menú o en el botón, no cerrar
  if (el && (el.contains(event.target) || button)) return;
  this.showMiniNav = false;
}

  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
.mini-nav-button {
  position: fixed;
  top: 1rem;
  left: 1rem;
  border: none;
  color: white;
  border-radius: 50%;
  width: 44px;
  height: 44px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  z-index: 9999;
}

.mini-side-nav {
  position: fixed;
  top: 1rem;
  left: 4.2rem;
  width: 190px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  z-index: 9998;
  overflow: hidden;
  animation: slideIn 0.2s ease;
}

.mini-nav-item {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  gap: 0.75rem;
  cursor: pointer;
  transition: background 0.2s;
  font-size: 0.9rem;
}

.mini-nav-item:hover {
  background: #f8fafc;
}

.mini-nav-icon {
  font-size: 1.2rem;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@keyframes slideIn {
  from {
    transform: translateX(-10px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>
